export default __webpack_public_path__ + "14200a97dea88b3b15f5b617edd2b3aa.png";